export const RECEITA_DTO_CONSULTA = {
  "nomeTributo": "IRRF",
  "codigo": "0561",
  "descricao": "IRRF - Rendimento do Trabalho Assalariado",
  "dataFimVigencia": "",
  "dataInicioVigencia": "01/01/1901",
  "administradaRfb": true
};
